import { handleActions } from 'redux-actions';
import * as templateCardActions from '../actions/templateCard';

let initState = {
  isLoading: false,
  errorMessage: '',
};

export const templateCard = handleActions(
  {
    [templateCardActions.getTemplateById]: state => {
      return { ...state, templateLoading: true };
    },
    [templateCardActions.getTemplateByIdSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        templateData: payload,
        templateLoading: false,
      };
    },
    [templateCardActions.getTemplateByIdFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        templateLoading: false,
      };
    },
    [templateCardActions.createTemplate]: state => {
      return { ...state, isLoading: true };
    },
    [templateCardActions.createTemplateSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        create: payload,
        isLoading: false,
      };
    },
    [templateCardActions.createTemplateError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        createErrors: payload,
        isLoading: false,
      };
    },
    [templateCardActions.updateTemplate]: state => {
      return { ...state, isLoading: true };
    },
    [templateCardActions.updateTemplateSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        create: payload,
        isLoading: false,
      };
    },
    [templateCardActions.updateTemplateError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        updateErrors: payload,
        isLoading: false,
      };
    },
    [templateCardActions.deleteTemplate]: (state, action) => {
      return {
        ...state,
        isLoading: true,
      };
    },
  },
  initState
);
